import { Component, Input } from '@angular/core';
import { FoodCostTarget } from '@usf/ngrx-inventory';

@Component({
  selector: 'app-food-cost-target',
  templateUrl: './food-cost-target.component.html',
  styleUrls: ['./food-cost-target.component.scss'],
})
export class FoodCostTargetComponent {
  @Input() foodCostTarget: FoodCostTarget;
  @Input() displayIcon = true;

  readonly foodCostTargetRef = FoodCostTarget;

  constructor() {}
}
